
export default function About() {
  return (
    <section className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-sm font-serif text-gray-600 mb-4">ABOUT FINE FRANK</p>
          <h2 className="text-6xl font-bold text-gray-900 leading-tight mb-4">
            <span className="font-sans">Building Trust Through</span><br />
            <span className="font-serif italic">Quality</span><br />
            <span className="font-sans">and Craftsmanship</span>
          </h2>
          <p className="text-lg text-gray-600 font-light">
            American-owned, locally operated
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 gap-8">
          {/* Card 1 */}
          <div className="bg-[#FF6B4A] rounded-2xl p-12 relative">
            <div className="absolute top-8 right-8 w-12 h-12 bg-white rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors">
              <i className="ri-arrow-right-up-line text-gray-900 text-xl"></i>
            </div>
            
            <div className="mb-8">
              <div className="text-8xl font-serif font-bold text-white mb-4">98%</div>
              <p className="text-xl text-white font-semibold mb-2">Customer Satisfaction Rate</p>
              <p className="text-white/80 text-sm">Based on completed projects</p>
            </div>
            
            <p className="text-white font-serif italic text-lg">
              Excellence in every detail
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#B8A5D6] rounded-2xl p-12 relative">
            <div className="absolute top-8 right-8 w-12 h-12 bg-white rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors">
              <i className="ri-arrow-right-up-line text-gray-900 text-xl"></i>
            </div>
            
            <div className="mb-8">
              <div className="text-8xl font-serif font-bold text-white mb-4">15+</div>
              <p className="text-xl text-white font-semibold mb-2">Years of Experience</p>
              <p className="text-white/80 text-sm leading-relaxed">
                Professional experience in home improvement and custom cabinetry manufacturing
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
